import React, { Component } from "react";
import { connect } from 'react-redux';

import {
    cadastrar
} from '../../actions'

//import '../login/sign.css'

class Cadastrar extends Component{
    constructor(){
        super()
        this.state = {
            form: {
                email: '',
                senha: '',
                cnpj: '',
                nome: ''
            }   
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.cadastrar = this.cadastrar.bind(this);
    }

    handleInputChange(event){
        var { form } = this.state
        form[event.target.name] = event.target.value

       this.setState({ form })
    }

    cadastrar(event){
        const { form } = this.state
        event.preventDefault()
        for( let i in form ) if(form[i].trim() == '' ) return alert('Preencha todos os campos!')
        
        this.props.cadastrar(form)
    }

    render(){
        const { loading_auth,error_auth } = this.props.auth

        return(
            <div className="principal" style={{width: '100%', marginTop:0,display:'flex'}}>
                <form className="form-signin" onSubmit={this.cadastrar}>
                    <img className="mb-4" src="/assets/imagem/logo.png" alt="" width="100" height="100" />
                    <h1 className="h3 mb-3 font-weight-normal">Cadastre-se agora</h1>
                    
                    <div className="form-group">
                        <label  className="sr-only">CPF/CNPJ</label>
                        <input maxLength="14" name="cnpj" type="text"  className="form-control" placeholder="CPF/CNPJ" required onChange={this.handleInputChange} />
                    </div>
                    
                    <div className="form-group">
                        <label  className="sr-only">Nome/Razão Social</label>
                        <input name="nome" type="text"  className="form-control" placeholder="Nome/Razão Social" required onChange={this.handleInputChange} />
                    </div>
                    
                    <div className="form-group">
                        <label  className="sr-only">E-mail</label>
                        <input name="email" type="email" id="inputEmail" className="form-control" placeholder="E-mail" required  onChange={this.handleInputChange} />
                    </div>

                    <div className="form-group">
                        <label  className="sr-only">Senha</label>
                        <input name="senha" type="password" id="inputPassword" className="form-control" placeholder="Senha" required onChange={this.handleInputChange} />
                    </div>

                    <div className="form-group">
                        <a  href="/login" > Já tenho conta </a>
                    </div>
        
                    <button className="btn btn-lg btn-primary btn-block" type="submit" role="button" disabled={loading_auth}>
                        {loading_auth ?<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>:null}
                        {loading_auth ? '   Aguarde...' : 'Entrar'}
                    </button>

                    
                    {error_auth != ''
                        ?<div className="alert alert-danger" role="alert" style={{marginTop:'5%'}}>
                            {error_auth}
                        </div>
                        :null
                    }
                    <p className="mt-5 mb-3 text-muted">&copy; RBMWEB 2019</p>
                </form>
            </div>
       )
    }
}

const mapStateToProps = ({ auth }) => {
    return {
        auth
    }
}

export default connect(mapStateToProps, {
    cadastrar
})(Cadastrar);